/*
  MENU ITEMS
  path - url path in browser to match active class to highlight item
  route name is the vue router route name
  admin true - only user with is_admin=1 will show menu
*/
export default [
    {
        title: "Home",
        routeName: "home",
        icon: "lni lni-home",
        paths: ["/home"],
        active: false,
    },


    {
        title: "Properties",
        icon: "lni  lni-apartment",
        paths: ["/collections", "/properties","/leases"],
        active: false,
        permissions: ["Manage properties"],
        childVisible: false,
        children: [
           
            {
                title: "Units & Properties",
                routeName: "properties",
                permissions: ["Manage properties"],
            }, 
            {
                title: "Leases",
                routeName: "leases",
                permissions: ["Manage properties"],
            },  
            {
                title: "Collections",
                routeName: "collections",
                permissions: ["Manage properties"],
            },         
        ],
    },

    {
        title: "Entities",
        icon: "lni lni-consulting",
        paths: ["/tenants","/contacts"],
        permissions: ["Manage tenants","Manage contacts"],
        active: false,
        childVisible: false,
        children: [  
            {
                title: "Tenants [Receivable]",
                routeName: "tenants",
                paths: ["/tenants"],
                active: false,
                permissions: ["Manage tenants"],
                childVisible: false,        
            },
            {
                title: "Contacts [Payable]",
                routeName: "contacts",
                paths: ["/contacts"],
                active: false,
                permissions: ["Manage contacts"],
                childVisible: false,        
            },
         ]
    },



   


    {
        title: "Accounting",
        routeName: "accounts",
        icon: "lni lni-coin",
        paths: ["/accounts"],
        permissions: ["Manage accounts"],
        active: false,
        childVisible: false,
        children: [         
            {
                title: "Accounts",
                routeName: "accounts",
                permissions: ["Manage accounts"],
            },
            {
                title: "Invoices [Receivable]",
                routeName: "accounts-invoices",
                permissions: ["Manage accounts"],
            },
            {
                title: "Expenses [Payable]",
                routeName: "accounts-expenses",
                permissions: ["Manage accounts"],
            },
            {
                title: "Payments ",
                routeName: "accounts-payments",
                permissions: ["Manage accounts"],
            },
            {
                title: "Credits",
                routeName: "accounts-credits",
                permissions: ["Manage accounts"],
            },
            {
                title: "Debits",
                routeName: "accounts-debits",
                permissions: ["Manage accounts"],
            },
            
        ],
    },

    {
        title: "Reports",
        routeName: "reports",
        icon: "lni  lni-library",
        paths: ["/reports"],
        active: false,
        permissions: ["View reports"],
        childVisible: false,        
    },


    
    {
        title: "System",
        icon: "lni lni-cogs",
        paths: ["/settings", "/companies", "parameters"],
        active: false,
        permissions: ["Manage settings", "Manage companies", "Manage schemes"],
        childVisible: false,
        children: [
           

            {
                title: "Parameters",
                routeName: "parameters",
                permissions: ["Manage companies"],
            },
            {
                title: "Company",
                routeName: "companies",
                permissions: ["Manage companies"],
            },
        ],
    },

    {
        title: "Users & Roles",
        icon: "lni lni-users",
        paths: ["/users", "/roles", "/user-logs"],
        active: false,
        permissions: ["Manage users", "Manage roles", "View user logs"],
        childVisible: false,
        children: [
            {
                title: "User Management",
                routeName: "users",
                permissions: ["Manage users"],
            },
            {
                title: "Roles Management",
                routeName: "roles",
                permissions: ["Manage roles"],
            },           
        ],
    },

    {
        title: "Admin",
        icon: "lni lni-warning",
        paths: ["/admin"],
        active: false,
        admin: true,
        childVisible: false,
        children: [
            {
                title: "Horizon Interface",
                routeName: "horizon",
            },
            {
                title: "Telescope Interface",
                routeName: "telescope",
            },
            {
                title: "User Logs",
                routeName: "user-logs",
                permissions: ["View user logs"],
            },
        ],
    },


];
